import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    standalone: false,
    selector: 'close-svg',
    templateUrl: './close-svg.component.html',
    styleUrls: ['./close-svg.component.scss']
})
export class CloseSvgComponent {
}
